var timeStore = {

	setStartTime: function (startTime) {
		if (this.state.startTime != startTime) {
			this.state.startTime = startTime;
			this.state.totalMilliseconds = this.state.endTime.getTime() - this.state.startTime.getTime();
			window.console.log('milisecons set to: ' + this.state.totalMilliseconds);
		}
		//this.totalMiliseconds = this.endDate.getTime() - this.startDate.getTime();
	},

	setEndTime: function (endtime) {
		if (this.state.endTime != endtime) {
			this.state.endTime = endtime;
			this.state.totalMilliseconds = this.state.endTime.getTime() - this.state.startTime.getTime();
		}
	},

	setNow: function (now) {
		this.state.now = now;
	},

	setAutoScroll: function (autoScroll) {
		this.state.autoScroll = autoScroll;
	},

	getZoom: function () {
		return parseInt(this.state.zoom);
	},

	setZoom: function (value) {
		window.localStorage.setItem('zoom', value);		
		this.state.zoom = value;
	},

	setTimeLineShowFuture :function(value) {
		window.localStorage.setItem('timelineShowFuture', value ? '1' : '0');
		this.state.timelineShowFuture = value;
    },

	setHistorySearch: function (value) {
		this.state.historySearch = value;
    },
	/**
	 * Sets the futurePending flag, depending the begintime
	 * @param {object} order a reference to the order which is set
	 */
	setOrderToFuture: function (order) {
		
		if ((order.startDate.getTime() - this.state.now.getTime()) > 1000 * 60 * 30) {
			order.futurePending = true;
		} else {
			if (order.futurePending !== false) {
				order.futurePending = false;
            }            			
		}
		return order.futurePending;
    },

	/**
	 * Calculates the left position in percentages
	 * @param {Date} orderDate
	 */
	calculateXPosition: function (time) {
		if (!time || !time.getTime) {
			return 0;
		}
		
		let startDate = this.state.startTime.getTime();		
		return (((time.getTime() - startDate) / this.state.totalMilliseconds) * 100);
	},


	/**
	 * Calculates the position in percentages
	 * @param {Object} batch
	 */
	calculateBatchPosition: function (batch) {

		if (!batch) {
			return 0;
		}

		batch.xposition = this.calculateXPosition(batch.startTime);
		return batch.xposition;
/*
		if (batch.relativeToNow) {
			batch.xposition = this.calculateXPosition(new Date(this.state.now.getTime() + (batch.relativeToNowTime * 1000)));
			return batch.xposition;
		}
		else {
			if (batch.startTime < this.state.startTime) {
				batch.xposition = 0;
				return 0;
			}
			batch.xposition = this.calculateXPosition(batch.startTime);
			return batch.xposition;
		}			*/

	},
	calculateBatchWidth: function (batch) {
		// only for testing purpose, doesnt get hit in production, because the empty orders are filtered on the server.
		if (batch.startTime < this.state.startTime) {
			var totalRecalculatedTime = ((batch.endTime.getTime() - this.state.startTime.getTime()) / 1000);
			return this.calculateWidth(totalRecalculatedTime);
		}
		batch.width = this.calculateWidth(batch.totalTime);
		return batch.width;
	},

	/**
	 * Calculates the percentage width in from the requested time in seconds
	 * @param {Number} timeinSeconds
	 */
	calculateWidth: function (timeinSeconds) {
		var percentage = (timeinSeconds / this.state.totalMilliseconds) * 100000;
		return percentage ;
	},

	/**
	 * The time state
	 */
	state: {
		startTime: new Date(),
		endTime: new Date(),
		now: new Date(),
		historySearch : false, // a value indicating the historical orders are shown.
		zoom: window.localStorage.getItem('zoom') || 3600,
		timelineShowFuture: window.localStorage.getItem('timelineShowFuture') == "1",
		/*
		* Gets or sets a value indicating wheter the timeline should scroll to the current time
		* **/
		autoScroll: true,

		totalMilliseconds :0
	},

	/**
	 * Adds [step] minutes to the date
	 * @param {any} date the date to add the minutes to, Caution!! the date is still a reference object.
	 * @param {any} step the ammount of minutes to add
	 * @returns the modified date object
	 */
	addMinutes: function (date, step) {		
		let minute = date.getMinutes();
		minute += step;
		date.setMinutes(minute);		
		return date;
	},

	/**
	 * Adds [step] hours to the date
	 * @param {any} date the date to add the hours to, Caution!! the date is still a reference object.
	 * @param {any} step the ammount of hours to add
	 * @returns the modified date object
	 */
	addHours: function (date, step) {
		let hour = date.getHours();
		hour += step;
		date.setHours(hour);
		return date;
	}
};





export { timeStore as default };